// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"48":"8a4910a52863d5100379","60":"9cfe992f0e43c6f17d70","232":"28c6a47e2d0ff0b13f07","375":"bfd4d3450589ff2b73a7","802":"8b6b30506bd4c30b9975"}[chunkId] + ".js";
};